import React from 'react';
import {Table} from 'semantic-ui-react';

const CombosTable = ({items}) => {
  return (
    <Table striped celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>ITEM</Table.HeaderCell>
          <Table.HeaderCell>DESCRIPCION</Table.HeaderCell>
          <Table.HeaderCell>CHASIS</Table.HeaderCell>
          <Table.HeaderCell>PEDIDO</Table.HeaderCell>
          <Table.HeaderCell>PRECIO</Table.HeaderCell>
          <Table.HeaderCell>TOTAL</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {
          items.map((item, index) => (
            <Table.Row key={index}>
              <Table.Cell>{item.codeCombo}</Table.Cell>
              <Table.Cell>{(item.description)}</Table.Cell>
              <Table.Cell>{item.chassis}</Table.Cell>
              <Table.Cell className="invoice-align-text-left">1</Table.Cell>
              <Table.Cell className="invoice-align-text-left">$ {item.total}</Table.Cell>
              <Table.Cell className="invoice-align-text-left">$ {item.total}</Table.Cell>
            </Table.Row>
          ))
        }
      </Table.Body>
    </Table>
  );
};

export default CombosTable;
